import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FeatureType, FuelRecordDefault, Grid, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { FuelRecordDefaultComponent } from './fuel-record-default.component'

@Component({
    templateUrl: './fuel-record-defaults.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class FuelRecordDefaultsComponent extends BaseComponent {
    faSearch = faSearch
    public grid: Grid<FuelRecordDefault>

    constructor() {
        super()
        this.grid = new Grid<FuelRecordDefault>(this.services)
            .setupModalEditing(
                this.services.data.fuelRecordDefaults,
                'Fuel Record Default',
                FuelRecordDefaultComponent,
                () => new FuelRecordDefault(),
                this,
                ModalSize.small,
            )
            .filterBy(item => [item.equipment, item.description, item.costCode, item.costType, item.offsetGl])
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.fuelRecordDefaults.queryAll()).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid.items = result[0]
                },
            }),
        )
    }
    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.UsersEdit])
    }
}
